// extracted by mini-css-extract-plugin
export default {"contentLayout":"SimpleLayout_contentLayout__DLbby","domainDisplay":"SimpleLayout_domainDisplay__CUr2r","relatedLinks":"SimpleLayout_relatedLinks__H-wIB"};